<template>
  <div class="d-flex position-fixed right-btn-group">
    <div class="btn btn-warning area-btn" @click="handleBtnClick">
      <i class="fa fa-caret-right" v-show="!isCollapsed"></i>
      <i class="fa fa-caret-left" v-show="isCollapsed"></i>
    </div>
    <div
      class="d-flex flex-column"
      :class="isCollapsed ? 'collapsed' : 'uncollapsed'"
    >
      <button
        v-for="(scenicArea, i) in scenicAreaList"
        :class="[
          'btn',
          'right-btn',
          'text-white',
          'font-weight-bold',
          targetIndex.includes(i) ? 'bg-red' : 'bg-indigo',
        ]"
        @click="routeToScenicArea(scenicArea, i)"
      >
        {{ scenicArea.name }}
      </button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CONST from "../utils/const";
import Utils from "../utils/utils";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      scenicAreaList: [],
      checkedScenicArea: [],
      targetIndex: [],
      isCollapsed: true,
    };
  },
  //使用Props 存取父層值的所有事件
  props: {
    propEventList: {
      type:[Array,Boolean],
      required: true,
    },
  },
  computed: {
    ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),
  },
  methods: {
    getAllScenicArea() {
      // 不顯示"秘書室"這個景區
      this.scenicAreaList = this.myScenicAreaList.filter(s =>s.id != 18 );
    },

    async checkHappendingEvent() {
      const newArray = new Set(); //取得不重複ScenicAreaName重組陣列
      const result = [];
      for (let i = 0; i < this.propEventList.length; i++) {
        const a = await this.propEventList[i].ScenicAreaName;
        newArray.add(a);
      }

      //找到相同的object index
      const eventName = Array.from(newArray);
      for (const name of eventName) {
        const index = this.scenicAreaList.findIndex(
          (area) => area.name === name
        );
        result.push(index);
        this.targetIndex = result;
      }
    },

    handleBtnClick() {
      this.isCollapsed = !this.isCollapsed;
    },

    routeToScenicArea(scenicArea, i) {
      if (scenicArea.id >= 0) {
        this.$router.push(`/scenicAreaInfo?id=${scenicArea.id}`);
      } else {
        return;
      }
    },
  },
  watch: {
    propEventList: {
      immediate: true,
      handler(newVal) {

        if (newVal.length > 0) {
          this.checkHappendingEvent();
        }
      },
    },

    myScenicAreaList: {
      handler(newVal) {
    
        this.getAllScenicArea();
      },
      immediate:true
    },
  },
  mounted() {

    this.checkHappendingEvent();
  },
};
</script>
<style lang="scss" scope>
.area-btn {
  margin: 5px 6px;
  height: 40px;
  padding: 6px 12px;

  // z-index:14;
}

.area-btn > i {
  font-size: 30px;
}
.btn:first-child:active {
  color: white;
}
.area-btn:active > i {
  color: white;
}

.right-btn-group {

  top: 130px;
  right: 2px;
  max-height: 80%;
  overflow-y:scroll;
  overflow-x: hidden;
  z-index: 12;
}

.right-btn {
  width: 120px;
  border-radius: 30px;
  margin: 3px;
  font-size: 14px;
  padding: 0.3rem 0;
  z-index: 12;



}

.bg-indigo:hover,
.bg-indigo:active {
  background-color: #5f8bcb;
}

.bg-red:hover,
.bg-red:active {
  background-color: #f86964;
}

.collapsed {
  margin-right: -130px;
  /* right: -100px; */
  overflow: hidden;
  transition: margin-right 0.5s ease;
  overflow-y:hidden;
  overflow-x: hidden;

  // height:50px;
  display: none;
 
  // z-index: 3;
  // pointer-events: none;
}

.uncollapsed {
  // max-height: 600px;
  margin-right: 0px;
  transition: margin-right 0.5s ease;
 


}
</style>
